export default {"src":"https://cdn.tanzhi.cn/_next/static/media/default-logo.ad9d5972.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};